import React from "react";
import { Navigate } from "react-router-dom";

import AuthLayout from "layouts/AuthLayout";
import HomeLayout from "layouts/HomeLayout";
//
import Health from "health";
import Lost from "404/index";
import NoAccess from "404/NoAccess";
import Login from "account/Login";
import Logout from "account/Logout";
//
import SwitchOrg from "account/SwitchOrg";
//
import Account from "account";
import Blog from "blog";
import DemoSurvey from "demosurvey";
import Dashboard from "dashboard";
import ActivityLog from "activityLog";
import Organizations from "organizations";
import Employees from "employees";
import EmployeeRecord from "employeeRecord";
import EmployeeLog from "employeeLog";
import EmployeeRecordList from "employeeRecordList";
import EmployeeRecordValue from "employeeRecordValue";
import Questions from "questions";
import Categories from "categories";
import CategoryCompliance from "categorycompliance";
import CategoryQuestions from "categoryQuestions";
import UserUpload from "UserUpload";
import AppUrl from "appurls";
import AppServer from "appserver";
import EmailTemplate from "EmailTemplate";
import PdfTemplate from "PdfTemplate";
import Settings from "settings";
import WebApiCred from "webApiCred";
import WebApiLog from "webApiLog";
import BriefScheduled from "briefScheduled";
import SurveyScheduled from "surveyScheduled";
import PdfReports from "PdfReport";
import MarketingRoi from "marketingRoi";
import WebImage from "WebImage";
import Gpt from "Gpt";
import SurveyStandard from "SurveyStandard"
import GptRecommendation from "GptRecommendation";
import GptRecommendationLog from "GptRecommendationLog";
import GptWebChat from "GptWebChat";
import MLOperations from "MLOperations"
import ReportTemplates from "ReportTemplates"
import ScheduleTemplate from "ScheduleTemplate"
import Documentation from "apiDocumentation";
import Product from "Product";
import PredictiveModel from "PredictiveModel";
import PresentationReport from "PresentationReport";
import StaffReports from "reports";
import Groups from "groups";
import Action from "action";
import SurveyAiLog from "survey_ai_log";
import LlmLog from "llmlog";
import PublicUpload from "PublicUpload";

import TaskTemplate from "TaskTemplate";
import TaskTemplateUserTask from "TaskTemplate/TaskTemplateUserTasks";
import TaskTemplateUserResponse from "TaskTemplate/TaskTemplateUserResponse";
import SlackTasks from "slackTasks";
import ServerScripts from "ServerScripts/index";

const routes = [
  {
    path: "app",
    element: <AuthLayout />,
    children: [
      { path: "dashboard/*", element: <Dashboard /> },
      { path: "activity-log/*", element: <ActivityLog /> },
      { path: "action/*", element: <Action /> },
      { path: "blogs/*", element: <Blog /> },
      { path: "organizations/*", element: <Organizations /> },
      { path: "employees/*", element: <Employees /> },
      { path: "employee-record/*", element: <EmployeeRecord /> },
      { path: "employee-log/*", element: <EmployeeLog /> },
      { path: "employee-record-list/*", element: <EmployeeRecordList /> },
      { path: "employee-record-value/*", element: <EmployeeRecordValue /> },
      { path: "questions/*", element: <Questions /> },
      { path: "categories/*", element: <Categories /> },
      { path: "survey-ai-log/*", element: <SurveyAiLog />},
      { path: "task-template/*", element: <TaskTemplate />},
      { path: "task-template-user-task/*", element: <TaskTemplateUserTask />},
      { path: "task-template-user-response/*", element: <TaskTemplateUserResponse />},
      { path: "product/*", element: <Product /> },
      { path: "gpt/*", element: <Gpt /> },
      { path: "user-uploads/*", element: <UserUpload /> },
      { path: "app-url/*", element: <AppUrl /> },
      { path: "app-server/*", element: <AppServer /> },
      { path: "demo-survey-response/*", element: <DemoSurvey /> },
      { path: "slack-tasks/*", element: <SlackTasks /> },
      { path: "settings/*", element: <Settings /> },
      { path: "email-templates/*", element: <EmailTemplate /> },
      { path: "pdf-templates/*", element: <PdfTemplate /> },
      { path: "brief-schedule/*", element: <BriefScheduled /> },
      { path: "predictive-model/*", element: <PredictiveModel /> },
      { path: "pdf-reports/*", element: <PdfReports />},
      { path: "llm-usage/*", element: <LlmLog /> },
      { path: "public-uploads/*", element: <PublicUpload /> },
      { path: "presentation-reports/*", element: <PresentationReport /> },
      { path: "staff-reports/*", element: <StaffReports /> },
      { path: "category-compliance/*", element: <CategoryCompliance /> },
      { path: "category-questions/*", element: <CategoryQuestions /> },
      { path: "survey-schedule/*", element: <SurveyScheduled /> },
      { path: "marketing-roi/*", element: <MarketingRoi /> },
      { path: "web-image/*", element: <WebImage /> },
      { path: "web-api-cred/*", element: <WebApiCred /> },
      { path: "web-api-log/*", element: <WebApiLog /> },
      { path: "survey-standard/*", element: <SurveyStandard /> },
      { path: "gpt-recommendation/*", element: <GptRecommendation /> },
      { path: "gpt-recommendation-log/*", element: <GptRecommendationLog /> },
      { path: "gpt-web-chat/*", element: <GptWebChat /> },
      { path: "ml-operations/*", element: <MLOperations /> },
      { path: "report-templates/*", element: <ReportTemplates /> },
      { path: "schedule-template-report/*", element: <ScheduleTemplate /> },
      { path: "api-documentation/*", element: <Documentation /> },
      { path : "server-scripts", element: <ServerScripts /> },
      { path: "groups/*", element: <Groups /> },
      { path: "404", element: <Lost /> },
      { path: "switch-org", element: <SwitchOrg /> },
      { path: "no-access", element: <NoAccess /> },
      { path: "*", element: <Navigate to="/app/404" /> },
    ],
  },
  {
    path: "/",
    element: <HomeLayout />,
    children: [
      { path: "", element: <Login /> },
      { path: "logout", element: <Logout /> },
      { path: "account/*", element: <Account /> },
      { path: "404", element: <Lost /> },
      { path: "no-access", element: <NoAccess /> },
      { path: "health", element: <Health /> },
      // { path: '*', element: <Navigate to="/404" /> }
    ],
  },
];

export default routes;
